import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { useDeleteNotificationHandlerNotificationHandlersIdDeleteMutation } from "api";

type DeleteHandlerDialogProps = {
  handlerId: string | null;
  onClose: () => void;
};

export function DeleteHandlerDialog({
  handlerId,
  onClose,
}: DeleteHandlerDialogProps) {
  const { t } = useTranslation();

  const [deleteHandler] =
    useDeleteNotificationHandlerNotificationHandlersIdDeleteMutation();

  return (
    <Dialog open={!!handlerId} onClose={onClose}>
      <DialogTitle>{t("delete_notification_handler")}</DialogTitle>
      <DialogContent dividers>
        {t("are_you_sure_you_want_to_delete_this_notification_handler")}
      </DialogContent>
      <DialogActions>
        <Button variant={"text"} onClick={onClose}>
          {t("Cancel")}
        </Button>
        <Button
          color={"error"}
          onClick={async () => {
            if (handlerId) {
              await deleteHandler({
                id: handlerId,
              });
            }

            onClose();
          }}
        >
          {t("ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
